import React from 'react';

export default function AddConsultant() {
  return (
    <div className="add-consultant-container">
     <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
     How do I Add a consultant?
            </h3> 

      {/* Step 1: Navigate to the Consultant Module */}
      <section className="step-section">
        <h2 className="step-heading">Step 1: Navigate to the Consultant Module</h2>
        <ol className="step-list">
          <li>
            <strong>From the dashboard</strong>, click on <em>Consultants</em> in the left-side menu.
          </li>
          <li>
            Select the <em>Add Consultant</em> option to open the consultant form.
          </li>
        </ol>
      </section>

      {/* Step 2: Fill in the Consultant Details */}
      <section className="step-section">
        <h2 className="step-heading">Step 2: Fill in the Consultant Details</h2>

        <h3>Basic Information</h3>
        <ul className="info-list">
          <li>
            <strong>First Name:</strong> Enter the consultant's first name in the provided field.
          </li>
          <li>
            <strong>Last Name:</strong> Enter the consultant's last name.
          </li>
          <li>
            <strong>Email:</strong> Enter a valid email address for the consultant.
          </li>
          <li>
            <strong>Password:</strong> Create a secure password for the consultant.
          </li>
        </ul>

        <h3>Contact Information</h3>
        <ul className="info-list">
          <li>
            <strong>Mobile Number:</strong>
            <ul>
              <li>Select the country code (e.g., +1 for the U.S.).</li>
              <li>Enter the consultant's mobile phone number.</li>
            </ul>
          </li>
          <li>
            <strong>WhatsApp Number:</strong>
            <ul>
              <li>If the WhatsApp number is the same as the mobile number, check the <em>Same As Mobile Number</em> box.</li>
              <li>Otherwise, select the country code and enter the WhatsApp number.</li>
            </ul>
          </li>
        </ul>
      </section>

      {/* Step 3: Assign Managing Roles */}
      <section className="step-section">
        <h2 className="step-heading">Step 3: Assign Managing Roles</h2>
        <ul className="info-list">
          <li>
            <strong>Managing Employer:</strong> Enter or select the employer responsible for this consultant.
          </li>
          <li>
            <strong>Managing Admin:</strong> Assign the admin responsible for overseeing the consultant.
          </li>
        </ul>
      </section>
      <img
                    src="   https://res.cloudinary.com/danfpnuui/image/upload/v1737787276/Consultant-2_zym12f.png"
                    alt="AI Resume Matcher"
                    className="placeholder-image 
 image_gatnix_support"
                />
      {/* Step 4: Save the Consultant */}
      <section className="step-section">
        <h2 className="step-heading">Step 4: Save the Consultant</h2>
        <ol className="step-list">
          <li>After completing all fields, review the information for accuracy.</li>
          <li>Click the <strong>Save</strong> button to add the consultant to the system.</li>
        </ol>
        <p>You have now successfully added a consultant! If you need further assistance, visit the Help Desk or contact support.</p>
      </section>
    </div>
  );
}
